import { IStatusInfoBoxProps } from './StatusInfoBox.types';
import { Stack } from '../index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { mergeClasses } from '@fluentui/react-components';
import { useStatusInfoBoxStyles } from './StatusInfoBox.styles';

const StatusInfoBox = (props: IStatusInfoBoxProps) => {
    const { className, isSuccessful, text } = props;

    const styles = useStatusInfoBoxStyles();
    const classes = mergeClasses(
        styles.statusMessageContainer,
        isSuccessful ? styles.successfulStatus : styles.failedStatus,
        className
    );

    return (
        <Stack horizontal className={classes}>
            {isSuccessful ? (
                <FontAwesomeIcon
                    icon={faCircleCheck}
                    className={mergeClasses(styles.statusSymbol, styles.successfulSymbol)}
                />
            ) : (
                <FontAwesomeIcon
                    icon={faCircleXmark}
                    className={mergeClasses(styles.statusSymbol, styles.failedSymbol)}
                />
            )}
            <p className={styles.statusMessage}>{text}</p>
        </Stack>
    );
};

export default StatusInfoBox;
